module.exports = __webpack_public_path__ + "static/media/password-icon.f5454a94.svg";